export default __webpack_public_path__ + "media/images/brighteon-social/logo-f6e105c63d0e3af41c377dc2a875d824.png";